import {DictionaryItem} from '@sa/rep-mdm';

export enum MapUnitId {
  MT_HA = 7,
  MT1000 = 8,
  HA1000 = 9,
  HA = 39,
  KG = 40,
  KG_HA = 41,
  PERCENT = 44,
  THOUSAND_HECTARES = 45,
  THOUSAND_METRIC_TONS = 46,

}

export class MapUnit {
  constructor(public id: MapUnitId, public name: string){

  }

  static fromDTO(payload: DictionaryItem) {
    const id = payload.getValue<MapUnitId>('id')!;
    const name = typeof payload.values['name'] !== 'object' 
      ? payload.getValue<string>('name')
      : payload.getValue<Record<number, string>>('name')![9];
    return new MapUnit(id, name!);
  }
}